// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Форсайт» (Foresight, ключ `pfore`, група `analysis`). */
export const foresightManifest: IModuleManifest = {
  key: 'pfore',
  group: 'analysis',
  slug: 'foresight',
  prefix: 'PFS',
  name: { en: 'Foresight', uk: 'Форсайт' },
  entities: [
    { key: 'pfore', slug: 'pfore', name: { en: 'Scenarios', uk: 'Сценарії' }, main: true },
    { key: 'ptrend', slug: 'ptrend', name: { en: 'Trends', uk: 'Тенденції' }, main: false },
    { key: 'psign', slug: 'psign', name: { en: 'Signposts', uk: 'Індикатори раннього попередження' }, main: false },
  ],
  loadState: () => import('./state/foresightSlice').then((m) => m.foresightSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
